import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Mail, ArrowLeft, CheckCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) { toast.error('Email adresinizi girin'); return; }
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
    } catch {
      toast.error('Bir hata olustu');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-bone flex items-center justify-center py-12 px-4">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link to="/" className="inline-block">
            <img src="/logo.png" alt="Central Restaurant" className="h-16 w-auto mx-auto" />
          </Link>
        </div>

        <div className="bg-white rounded-2xl p-8 shadow-lg">
          {sent ? (
            <div className="text-center py-4">
              <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
              <h2 className="font-playfair text-2xl font-bold text-charcoal mb-2">Email Gonderildi!</h2>
              <p className="text-charcoal/60 mb-6">
                Eger <strong>{email}</strong> adresi kayitliysa, sifre sifirlama linki gonderildi. Lutfen email kutunuzu kontrol edin.
              </p>
              <Link to="/login">
                <Button className="bg-terracotta text-white hover:bg-terracotta/90 rounded-full px-8" data-testid="back-to-login-btn">
                  <ArrowLeft className="w-4 h-4 mr-2" />Giris Sayfasina Don
                </Button>
              </Link>
            </div>
          ) : (
            <>
              <h1 className="font-playfair text-2xl font-bold text-charcoal text-center mb-2">Sifremi Unuttum</h1>
              <p className="text-charcoal/60 text-center mb-8">
                Email adresinizi girin, size sifre sifirlama linki gonderelim
              </p>

              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <Label className="text-charcoal">E-posta</Label>
                  <div className="relative mt-1">
                    <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-charcoal/40" />
                    <Input
                      type="email"
                      placeholder="ornek@email.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="pl-10"
                      required
                      data-testid="forgot-email-input"
                    />
                  </div>
                </div>

                <Button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-terracotta text-white hover:bg-terracotta/90 rounded-full py-6 text-base font-semibold"
                  data-testid="forgot-submit-btn"
                >
                  {loading ? (
                    <div className="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent" />
                  ) : 'Sifirlama Linki Gonder'}
                </Button>
              </form>

              <div className="mt-6 text-center">
                <Link to="/login" className="text-terracotta font-semibold hover:underline flex items-center justify-center gap-1">
                  <ArrowLeft className="w-4 h-4" /> Giris sayfasina don
                </Link>
              </div>
            </>
          )}
        </div>
      </motion.div>
    </div>
  );
};

export default ForgotPassword;
